import {
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
  AfterViewInit,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

import { AppConfig } from "../../app.config";
import { HRJoinersDetailsComponent } from "./joiners/hr-joiners-details.component";
import { HRAttritionDetailsComponent } from "./attrition/hr-attrition-details.component";
import { HRLoPDetailsComponent } from "./lop/hr-lop-details.component";
import { HROtherEarningsDetailsComponent } from "./otherearnings/hr-otherearnings-details.component";

import { HRDesignationChangesDetailsComponent } from "./designationchanges/hr-designationchanges-details.component";
import { HRDeductionDetailsComponent } from "./deduction/hr-deduction.details.component";
import { MatDialog, MatTabChangeEvent } from "@angular/material";
import { EmployeeService } from "../../shared/service/employee.service";
import { HRAllowancesDetailsComponent } from "./allowances/hr-allowances-details.component";
import { arLocale } from "ngx-bootstrap";
import { UserService } from "../../shared/service/user.service";
import { MonthClosureService } from "../../shared/service/month-closure.service";
import { ConfirmDialogComponent, ConfirmDialogModel } from "../../shared/components/confirm-dialog/confirm-dialog.component";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-hr-month-closure",
  templateUrl: "./hr-month-closure.component.html",
  styleUrls: ["./hr-month-closure.component.css"],
})
export class HrMonthClosureComponent implements AfterViewInit, OnInit {
  @ViewChild(HRJoinersDetailsComponent, { static: false })
  hrJoinersDetailsComponent: HRJoinersDetailsComponent;
  @ViewChild(HRAttritionDetailsComponent, { static: false })
  HRAttritionDetailsComponent: HRAttritionDetailsComponent;
  @ViewChild(HRLoPDetailsComponent, { static: false })
  HRLoPDetailsComponent: HRLoPDetailsComponent;
  @ViewChild(HROtherEarningsDetailsComponent, { static: false })
  hrOtherEarningsDetailsComponent: HROtherEarningsDetailsComponent;
  @ViewChild(HRDeductionDetailsComponent, { static: false })
  hrDeductionDetailsComponent: HRDeductionDetailsComponent;
  @ViewChild(HRDesignationChangesDetailsComponent, { static: false })
  hrDesignationChangesDetailsComponent: HRDesignationChangesDetailsComponent;
  @ViewChild(HRAllowancesDetailsComponent, { static: false })
  hrAllowancesDetailsComponent: HRAllowancesDetailsComponent;
  financialYear: any;
  currentFY: any;
  months: any;
  currentMonth: any;
  runningMonth = "";
  tab1 = false;
  tab2 = false;
  tab3 = false;
  tab4 = false;
  tab5 = false;
  tab6 = false;
  tab7 = false;
  currentIndex = 0;
  IsEmployeeAccess = false;
  employeeDetails = [];
  error: any;
  enableAfter=false;
  permission:any;
  constructor(
    private route: ActivatedRoute,
    private config: AppConfig,
    public router: Router,
    public _employeeservice: EmployeeService,
    public _userService: UserService,
    public monthClosure: MonthClosureService,
    private dialog: MatDialog,
    private toastr: ToastrService,
  ) {}

  ngOnInit() {
    var date = new Date();
    this.financialYear = [];
    this.months = [];

    this.permission=false
    let permissionAPI = this._userService.getApplicationDetails();
    let filterpermission = permissionAPI.filter((c) => c.Name == "MonthClose")[0];
    if (filterpermission != null)
    {
      if(!filterpermission.IsEmployee)
      this.permission=filterpermission.HasFullAccess || filterpermission.ReadOnlyPermission;
      this.IsEmployeeAccess = filterpermission.IsEmployee;
      
    }

    this.loadFinancialYears();
    this.getAllEmployees();
    //this.hrJoinersDetailsComponent.getJoiners();
  }
  ngAfterViewInit() {
    if(!!this.hrAllowancesDetailsComponent && this.IsEmployeeAccess)
      {
      this.hrAllowancesDetailsComponent.currentFY = this.currentFY;
      this.hrAllowancesDetailsComponent.IsEmployeeAccess =
      this.IsEmployeeAccess;
      this.hrAllowancesDetailsComponent.IsEmployeeAccess =
        this.IsEmployeeAccess;
        this.hrAllowancesDetailsComponent.currentMonth = this.currentMonth;
        var date = new Date();
        var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);

        this.hrAllowancesDetailsComponent.employeeDetails =
          this.employeeDetails.filter(
            (value) =>
              value.DateOfExit == null || new Date(value.DateOfExit) >= firstDay
          );
        this.hrAllowancesDetailsComponent.getAllowancesDetails();
        
      
      }
      else{
    this.checkFreezDate();
    if(!!this.hrJoinersDetailsComponent)
    {
    this.hrJoinersDetailsComponent.currentMonth = this.currentMonth;
    this.hrJoinersDetailsComponent.getVendors();
    this.hrJoinersDetailsComponent.currentFY = this.currentFY;
    }
    if(!!this.hrJoinersDetailsComponent)
    this.HRAttritionDetailsComponent.currentFY = this.currentFY;
    if(!!this.HRLoPDetailsComponent)
    this.HRLoPDetailsComponent.currentFY = this.currentFY;
    if(!!this.hrOtherEarningsDetailsComponent)
    this.hrOtherEarningsDetailsComponent.currentFY = this.currentFY;
    if(!!this.hrDeductionDetailsComponent)
    this.hrDeductionDetailsComponent.currentFY = this.currentFY;
  if(!!this.hrAllowancesDetailsComponent)
  {
    this.hrAllowancesDetailsComponent.currentFY = this.currentFY;
    this.hrAllowancesDetailsComponent.IsEmployeeAccess =
    this.IsEmployeeAccess;
    
  }
    this.hrAllowancesDetailsComponent.IsEmployeeAccess =
      this.IsEmployeeAccess;
    if(!!this.hrDesignationChangesDetailsComponent)
    {
    this.hrDesignationChangesDetailsComponent.currentMonth = this.currentMonth;
    this.hrDesignationChangesDetailsComponent.currentFY = this.currentFY;
    }
  }
   
  }
  loadFinancialYears(): void {
    const startYear = 2015;
    const now = new Date();
    const mm = now.getMonth() + 1;
    let currentYear = now.getFullYear();
    let year = now.getFullYear().toString().substr(2, 2);

    for (let i = startYear; i <= currentYear; i++) {
      this.financialYear.push({
        FinancialYearId: i.toString().substr(2, 2),
        FinancialYear: `${i}-${(i + 1).toString().substr(2, 2)}`,
      });
    }

    if (mm > 3) {
      currentYear = now.getFullYear();
    } else {
      currentYear = now.getFullYear() - 1;
    }

    year = currentYear.toString().substr(2, 2);
    this.currentFY = `${currentYear}-${parseInt(year) + 1}`;

    this.loadeMonths(parseInt(year));
  }

  loadeMonths(year: any): void {
    year = parseInt(year);
    const months: any[] = [];
    const monthNames = [
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
      "Jan",
      "Feb",
      "Mar",
    ];
    const monthValues = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const now = new Date();
    const mm = now.getMonth() + 1;
    let countMonths = 12;

    if (mm > 0 && mm < 4) {
      countMonths = 18;
    }

    for (let i = 0; i < 12; i++) {
      const monthName =
        i < 9 ? `${monthNames[i]}-${year}` : `${monthNames[i]}-${year + 1}`;

      months.push({
        lookupCode: monthName,
        description: monthName,
        monthValue: i,
      });
    }

    if (year === parseInt(now.getFullYear().toString().substr(2, 2))) {
      this.currentMonth = months.find(
        (n) => n.lookupCode.split("-")[0] === monthValues[now.getMonth()]
      ).lookupCode;
      this.runningMonth = months.find(
        (n) => n.lookupCode.split("-")[0] === monthValues[now.getMonth()]
      ).lookupCode;
    } else {
      //this.currentMonth = "Apr-" + year;
    }

    this.months = months;
  }
  getAllEmployees() {
    this._employeeservice.getAllEmployees().subscribe(
      (data: any[]) => {
        this.employeeDetails = data; 
        if(!!this.hrAllowancesDetailsComponent)
        {
          var date = new Date();
          var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        this.hrAllowancesDetailsComponent.employeeDetails =
        this.employeeDetails.filter(
          (value) =>
            value.DateOfExit == null || new Date(value.DateOfExit) >= firstDay
        );
      }
        //.filter(c=>c.EmpCode!=this._userService.getEmpCode());
      },
      (error) => (this.error = error)
    );
  }
  financialYearChange() {
    if (this.currentFY != "" && this.currentFY != null) {
      var year = this.currentFY.substr(0, 4);
      year = year.toString().substr(2, 2);
      this.loadeMonths(year);
    }
  }
  currentMonthChange() {
    this.tab1 = false;
    this.tab2 = false;
    this.tab3 = false;
    this.tab4 = false;
    this.tab5 = false;
    this.tab6 = false;
    this.tab7 =false;
    if(!!this.hrAllowancesDetailsComponent && this.IsEmployeeAccess)
      {
        this.hrAllowancesDetailsComponent.IsEmployeeAccess =
        this.IsEmployeeAccess;

        this.hrAllowancesDetailsComponent.currentMonth = this.currentMonth;
        var date = new Date();
        var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);

        this.hrAllowancesDetailsComponent.employeeDetails =
          this.employeeDetails.filter(
            (value) =>
              value.DateOfExit == null || new Date(value.DateOfExit) >= firstDay
          );
        this.hrAllowancesDetailsComponent.getAllowancesDetails();
        this.hrAllowancesDetailsComponent.getEmployeeAllowances();
        this.hrAllowancesDetailsComponent.getApproverEmployeeList();
        this.hrAllowancesDetailsComponent.getInWardEmployeeList();
        this.hrAllowancesDetailsComponent.getCompletLogEmployeeAllowances();
    
      }
      else
    this.setTabIndex(this.currentIndex);
  }
  onTabChange(event: any) {
    this.tab1 = false;
    this.tab2 = false;
    this.tab3 = false;
    this.tab4 = false;
    this.tab5 = false;
    this.tab6 = false;
    this.tab7 =false;
    this.hrAllowancesDetailsComponent.selectedTabIndex=0;
    if (this.runningMonth != this.currentMonth)
      this.currentMonth = this.runningMonth;
    this.currentIndex = event.index;
    this.hrJoinersDetailsComponent.currentMonth = this.currentMonth;
    this.checkFreezDate();
    this.setTabIndex(event.index);
    // if ((this.tab1 == false && event.index == 0)) {
    // } else {
    //   this.tab1=true;
    // }
  }
  Export() {
    this.monthClosure.ExportToExcel(this.currentMonth);
  }
  checkFreezDate() {
    
    this.HRLoPDetailsComponent.isFreeze = true;
    this.hrOtherEarningsDetailsComponent.isFreeze = true;
    this.hrDeductionDetailsComponent.isFreeze = true;
    this.hrDesignationChangesDetailsComponent.isFreeze = true;
    this.hrJoinersDetailsComponent.isFreeze = true;
    this.HRAttritionDetailsComponent.isFreeze = true;
    this.enableAfter=false;
    var months = [
      "jan",
      "feb",
      "mar",
      "apr",
      "may",
      "jun",
      "jul",
      "aug",
      "sep",
      "oct",
      "nov",
      "dec",
    ];
    var curentMonthDay = months.indexOf(
      this.currentMonth.split("-")[0].toLowerCase()
    );
    var currentSelectedMonth = this.currentMonth.split("-");
    if (
      curentMonthDay == new Date().getMonth() ||
      curentMonthDay > new Date().getMonth()
    ) {
      this.hrJoinersDetailsComponent.isFreeze = false;
      this.HRAttritionDetailsComponent.isFreeze = false;
      this.HRLoPDetailsComponent.isFreeze = false;
      this.hrOtherEarningsDetailsComponent.isFreeze = false;
      this.hrDeductionDetailsComponent.isFreeze = false;
      this.hrDesignationChangesDetailsComponent.isFreeze = false;
      if (
        new Date() >
        new Date(20 + this.currentMonth.split("-")[1], curentMonthDay, 27, 11)
      ) {
        this.HRLoPDetailsComponent.isFreeze = true;
        this.hrOtherEarningsDetailsComponent.isFreeze = true;
        this.hrDeductionDetailsComponent.isFreeze = true;
        this.hrDesignationChangesDetailsComponent.isFreeze = true;
      }
      if (
        new Date() <
        new Date(20 + this.currentMonth.split("-")[1], curentMonthDay, 20, 11)
      ) {
      this.enableAfter=true;
      }
    }
    if (curentMonthDay + 1 == new Date().getMonth()) {
      if (
        new Date() <
        new Date(20 + this.currentMonth.split("-")[1], new Date().getMonth(), 4)
      ) {
        this.hrJoinersDetailsComponent.isFreeze = false;
        this.HRAttritionDetailsComponent.isFreeze = false;
      } else {
        this.hrJoinersDetailsComponent.isFreeze = true;
        this.HRAttritionDetailsComponent.isFreeze = true;
      }
    }
    if (this._userService.getDepartment()=="Finance" && curentMonthDay  == new Date().getMonth()) {
      if (
        new Date() <
        new Date(20 + this.currentMonth.split("-")[1], new Date().getMonth()+1, 7)
      ) {
        this.hrJoinersDetailsComponent.isFreeze = false;
        this.HRAttritionDetailsComponent.isFreeze = false;
        this.HRLoPDetailsComponent.isFreeze = false;
        this.hrOtherEarningsDetailsComponent.isFreeze = false;
        this.hrDeductionDetailsComponent.isFreeze = false;
        this.hrDesignationChangesDetailsComponent.isFreeze = false;
      } else {
        this.hrJoinersDetailsComponent.isFreeze = true;
        this.HRAttritionDetailsComponent.isFreeze = true;
        this.HRLoPDetailsComponent.isFreeze = true;
        this.hrOtherEarningsDetailsComponent.isFreeze = true;
        this.hrDeductionDetailsComponent.isFreeze = true;
        this.hrDesignationChangesDetailsComponent.isFreeze = true;

      }
    }
    let permission = this._userService.getApplicationDetails();
    let filterpermission = permission.filter((c) => c.Name == "MonthClose")[0];
    if (filterpermission != null)
    {
      this.IsEmployeeAccess = filterpermission.IsEmployee;
      if(filterpermission.ReadOnlyPermission)
      {
        this.hrJoinersDetailsComponent.isFreeze = true;
        this.HRAttritionDetailsComponent.isFreeze = true;
        this.HRLoPDetailsComponent.isFreeze = true;
        this.hrOtherEarningsDetailsComponent.isFreeze = true;
        this.hrDeductionDetailsComponent.isFreeze = true;
        this.hrDesignationChangesDetailsComponent.isFreeze = true;
        this.hrAllowancesDetailsComponent.isFreeze = true;
      }
      
    }

  }
  deducitonaddRow()
  {
    this.hrDeductionDetailsComponent.addRow();
  }
  earaningaddRow()
  {
    this.hrOtherEarningsDetailsComponent.addRow();
  }
  lopaddRow()
  {
    this.HRLoPDetailsComponent.addRow();
  }
  setTabIndex(index) {
    this.checkFreezDate();
    if (index == 0) {
      if (this.tab1 == false) {
        this.hrJoinersDetailsComponent.currentMonth = this.currentMonth;
        this.hrJoinersDetailsComponent.getJoiners();
        

        this.tab1 = true;
      } else {
        this.tab1 = true;
      }
    }
    if (index == 1) {
      if (this.tab2 == false) {
        this.HRAttritionDetailsComponent.currentMonth = this.currentMonth;
        this.HRAttritionDetailsComponent.getAttritionDetails();

        this.tab2 = true;
      } else {
        this.tab2 = true;
      }
    }
    if (index == 2) {
      if (this.tab3 == false) {
        this.HRLoPDetailsComponent.currentMonth = this.currentMonth;
        var date = new Date();
        var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        var today = new Date();
        var lastDayOfMonth = new Date(
          today.getFullYear(),
          today.getMonth() + 1,
          0
        );
        this.HRLoPDetailsComponent.employeeDetails =
          this.employeeDetails.filter(
            (value) =>
              value.DateOfExit == null ||
              (new Date(value.DateOfExit) >= firstDay &&
                new Date(value.DateOfExit) <= lastDayOfMonth)
          );
//this.HRLoPDetailsComponent.employeeList=this.employeeDetails
        this.HRLoPDetailsComponent.getLoPDetails();
        this.tab3 = true;
      } else {
        this.tab3 = true;
      }
    }
    if (index == 3) {
      if (this.tab4 == false) {
        this.hrOtherEarningsDetailsComponent.currentMonth = this.currentMonth;
        var date = new Date();
        var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);

        this.hrOtherEarningsDetailsComponent.employeeDetails =
          this.employeeDetails.filter(
            (value) =>
              value.DateOfExit == null || new Date(value.DateOfExit) >= firstDay
          );

        this.hrOtherEarningsDetailsComponent.getOtherEarningDetails();
        this.tab4 = true;
      } else {
        this.tab4 = true;
      }
    }
    if (index == 4) {
      if (this.tab5 == false) {
        var date = new Date();
        var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        this.hrDeductionDetailsComponent.currentMonth = this.currentMonth;
        this.hrDeductionDetailsComponent.employeeDetails =
          this.employeeDetails.filter(
            (value) =>
              value.DateOfExit == null || new Date(value.DateOfExit) >= firstDay
          );

        this.hrDeductionDetailsComponent.getDeductionDetails();
        this.tab5 = true;
      } else {
        this.tab5 = true;
      }
    }
    if (index == 5) {
      if (this.tab6 == false) {
        var date = new Date();
        var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        this.hrDesignationChangesDetailsComponent.currentMonth =
          this.currentMonth;
        this.hrDesignationChangesDetailsComponent.employeeDetails =
          this.employeeDetails.filter(
            (value) =>
              value.DateOfExit == null || new Date(value.DateOfExit) >= firstDay
          );
        this.hrDesignationChangesDetailsComponent.currentMonth =
          this.currentMonth;
        this.hrDesignationChangesDetailsComponent.getDesignationChanges();
        this.tab6 = true;
      } else {
        this.tab6 = true;
      }
    }
    if (index == 6) {
      this.hrAllowancesDetailsComponent.IsEmployeeAccess =
        this.IsEmployeeAccess;
      if (this.tab7 == false) {
        this.hrAllowancesDetailsComponent.currentMonth = this.currentMonth;
        var date = new Date();
        var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);

        this.hrAllowancesDetailsComponent.employeeDetails =
          this.employeeDetails.filter(
            (value) =>
              value.DateOfExit == null || new Date(value.DateOfExit) >= firstDay
          );
        this.hrAllowancesDetailsComponent.getAllowancesDetails();
        this.hrAllowancesDetailsComponent.getEmployeeAllowances();
        this.hrAllowancesDetailsComponent.getApproverEmployeeList();
        this.hrAllowancesDetailsComponent.getInWardEmployeeList();
        this.hrAllowancesDetailsComponent.getCompletLogEmployeeAllowances();
        this.tab7 = true;
      } else {
        this.tab7 = true;
      }
    }
  }

  confirmFreeze(index: number) {
    const message = "Are you sure you want to freeze the record(s)?";
    const dialogData = new ConfirmDialogModel("Confirm Freeze", message, "Submit", "OK", "Cancel");
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "500px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult) {
        this.isFreeze(index);  
        //this.toastr.success("Freezed Successfully");
      }
    });

  }

  isFreeze(index) {
    if (index == 0) {
      this.hrJoinersDetailsComponent.isFreeze = true;
      this.hrJoinersDetailsComponent.saveJoinerDetails();
    }
    if (index == 1) {
      this.HRAttritionDetailsComponent.isFreeze = true;
      this.HRAttritionDetailsComponent.saveAttritionDetails();
    }
    if (index == 2) {
      this.HRLoPDetailsComponent.isFreeze = true;
      this.HRLoPDetailsComponent.saveLopDetails();
    }
    if (index == 3) {
      this.hrOtherEarningsDetailsComponent.isFreeze = true;
      this.hrOtherEarningsDetailsComponent.saveOtherEarningsDetails();
    }

    if (index == 4) {
      this.hrDeductionDetailsComponent.isFreeze = true;
      this.hrDeductionDetailsComponent.saveDectionDetails();
    }
    if (index == 5) {
      this.hrDesignationChangesDetailsComponent.isFreeze = true;
      this.hrDesignationChangesDetailsComponent.saveResignationCommentsDetails();
    }
    if (index == 6) {
      this.hrAllowancesDetailsComponent.isFreeze = true;
      this.hrAllowancesDetailsComponent.saveAllowancessDetails();
    }
  }
  save(index) {
    if (index == 0) {
      this.hrJoinersDetailsComponent.saveJoinerDetails();
    }
    if (index == 1) {
      this.HRAttritionDetailsComponent.saveAttritionDetails();
    }
    if (index == 2) {
      this.HRLoPDetailsComponent.saveLopDetails();
    }
    if (index == 3) {
      this.hrOtherEarningsDetailsComponent.saveOtherEarningsDetails();
    }

    if (index == 4) {
      this.hrDeductionDetailsComponent.saveDectionDetails();
    }
    if (index == 5) {
      this.hrDesignationChangesDetailsComponent.saveResignationCommentsDetails();
    }
    if (index == 6) {
      this.hrAllowancesDetailsComponent.saveAllowancessDetails();
    }
  }
}
